import { render, staticRenderFns } from "./shelter-areas-list.vue?vue&type=template&id=3bd7aa16&scoped=true"
import script from "./shelter-areas-list.vue?vue&type=script&lang=js"
export * from "./shelter-areas-list.vue?vue&type=script&lang=js"
import style0 from "./shelter-areas-list.vue?vue&type=style&index=0&id=3bd7aa16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd7aa16",
  null
  
)

export default component.exports